// Paylaşılan sayfalama bileşeni — liste sayfaları için tek tip pager.
// totalPages <= 1 ise hiçbir şey render etmez (parent koşul yazmasın diye).
import React from 'react';
import Button from './Button';

export default function Pager({ page, totalPages, onChange, className = '', style = null }) {
  if (!totalPages || totalPages <= 1) return null;
  const go = (p) => { const next = Math.max(1, Math.min(totalPages, p)); if (next !== page) onChange(next); };
  return (
    <div className={'ui-pager ' + className} style={style || undefined}>
      <Button variant="ghost" size="sm" onClick={() => go(page - 1)} disabled={page <= 1}>‹ Önceki</Button>
      <span className="ui-pager-info">{page} / {totalPages}</span>
      <Button variant="ghost" size="sm" onClick={() => go(page + 1)} disabled={page >= totalPages}>Sonraki ›</Button>
    </div>
  );
}
